import CONFIG from "config/config";
import { ensureThanosWidgetFixtureRegistered } from "./thanosWidgetFixture";

let scriptInjected = false;

/**
 * Loads the `<thanos-review-widget>` custom element definition.
 *
 * SINGLE SWAP POINT for HUB-455 (D1, phase 4): once the real widget ships and
 * `REACT_APP_THANOS_WIDGET_URL` (CONFIG.THANOS_WIDGET_URL) is set, this
 * injects the real `<script src>` (same pattern as the existing
 * `@oppizi-ecosystem/meeting` embed) instead of registering the local
 * fixture — no other file under reviewOffer/ needs to change, since both
 * paths define the same `thanos-review-widget` tag/attributes/events.
 */
export const mountThanosWidget = (): void => {
  if (CONFIG.THANOS_WIDGET_URL) {
    if (scriptInjected || document.querySelector("script[data-thanos-widget]")) return;
    const script = document.createElement("script");
    script.src = CONFIG.THANOS_WIDGET_URL;
    script.async = true;
    script.dataset.thanosWidget = "true";
    document.head.appendChild(script);
    scriptInjected = true;
    return;
  }
  ensureThanosWidgetFixtureRegistered();
};
